<template>
  <div class="recommendation-container">
    <div class="titleBox">
      <span class="title">
        为你推荐
        <!-- 装饰-左 -->
        <div class="decoration left">
          <div class="decoration-line"></div>
        </div>
        <!-- 装饰-右 -->
        <div class="decoration right">
          <div class="decoration-line"></div>
        </div>
      </span>
    </div>
    <div class="listBox">
      <div class="listContainer">
        <div class="goodList">
          <div class="goodItem" v-for="good of goodList" :key="good.commodityId" @click="handleGoodDetail(good)">
            <div class="img">
              <img :src="getCommodityImg(good)" alt="">
              <img v-if="Number(good.reserve) === 0" class="soldOut1" src="@/assets/images/pt-soldOut.png" alt="">
            </div>
            <div class="info">
              <div>
                <div class="storeCommodity">
                  <img class="UImg" v-if="good.storeType === 'U'" src="@/assets/images/pt-yxdp.png" alt="">
                  <img class="SImg" v-if="good.storeType === 'S'" src="@/assets/images/pt-zy.png" alt="">
                  <div class="commodityName">{{ good.commodityName }}</div>
                </div>
                <div class="commodityTag">
                  <span class="tag" v-for="tag of good.tags" :key="tag.tagId">{{ tag.tagName }}</span>
                </div>
              </div>
              <div class="price">
                <span class="retail" v-if="good.pays[0].payType === 1">
                  <span class="symbol">¥</span>{{ getRetailPriceMin(good).retailPrice }}
                </span>
                <span class="retail" v-if="good.pays[0].payType === 2">
                  {{ getRetailPriceMin(good).retailPrice }}&nbsp;提货值
                </span>
                <span class="original" v-if="good.pays[0].payType === 1">
                  <span class="symbol">¥</span>{{ getRetailPriceMin(good).skuPrice }}</span>
                <span class="original" v-if="good.pays[0].payType === 2">
                  {{ getRetailPriceMin(good).skuPrice }}&nbsp;提货值
                </span>
                <span class="sold">已售{{ good.salesNumber }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="noMore" v-show="goodList.length <= 0">
          暂无数据
        </div>
        <div class="load-data">
          <div class="good-loading" v-show="isLoadData">
            <i class="el-icon-loading loading-icon"></i>
            <div>页面加载中</div>
          </div>
          <div class="good-last" v-show="isLast && !isLoadData && goodList.length > 0">没有更多了</div>
        </div>
        <!-- 分页 -->
        <!-- <el-row v-if="pageData.total" style="margin-top:10px">
          <el-col :span="24" class="paginateWrap">
            <el-pagination
              popper-class="_popStyle"
              :current-page="pageData.currentPage"
              :page-sizes="pageData.pageSizes"
              :page-size="pageData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageData.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </el-col>
        </el-row> -->
      </div>
    </div>
  </div>
</template>

<script>
/*global protocol http */
export default {
  data() {
    return {
      goodList: [],
      // 分页相关
      pageData: {
        total: null,
        pageSizes: [8, 16, 32, 64],
        pageSize: 8,
        currentPage: 1
      },
      isLoadData: false, // 加载状态
      isLast: false // 已加载所有数据
    }
  },
  created() {
    this.getCommoditye()
  },
  methods: {
    handleGoodDetail(good) {
      this.$router.push({
        name: 'ptOrdinaryGoodDetail',
        query: {
          commodityId: good.commodityId,
          storeId: good.storeId,
        }
      })
    },
    // 提取商品主图
    getCommodityImg(commodity) {
      return commodity.imgs.find(img => Number(img.isMain) === 1).img
    },
    // 提取零售价(所有规格的最低价格)
    getRetailPriceMin(commodity) {
      let minObj = commodity.skus[0]
      commodity.skus.forEach(sku => {
        if (Number(sku.retailPrice) < Number(minObj.retailPrice) && Number(sku.display) === 1) {
          minObj = sku
        }
      })
      return minObj
    },
    getCommoditye() {
      if (this.isLoadData) return // 正在加载
      this.isLoadData = true
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryCommodity))
      apiObj.param = {
        sort: [{
          direction: 'DESC',
          property: 'sortId'
        }],
        page: this.pageData.currentPage - 1,
        size: this.pageData.pageSize
      }
      http.postFrontMall(apiObj).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.pageData.total = value.totalElements
          if (this.isLast) {
            return
          } else {
            this.isLast = value.last
          }
          this.pageData.currentPage++ // 页数增加
          if (!this.goodList.length) {
            this.goodList = [...value.content]
          } else {
            this.goodList = [...this.goodList, ...value.content]
          }
        } else {
          this.$message(message)
        }
      }).finally(() => {
        this.isLoadData = false
      })
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.getCommoditye()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.getCommoditye()
    }
  }
}
</script>

<style scoped lang="scss">
  .recommendation-container {
    // background: red;
    width: 1200px;
    margin: 20px auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    .titleBox {
      width: 100%;
      text-align: center;
      position: relative;
      .title {
        color: #333333;
        font-size: 20px;
        position: relative;
        font-weight: 500;
        .decoration {
          position: absolute;
          width: 10px;
          height: 10px;
          background: #7CC4F0;
          border-radius: 50%;
          top: 50%;
          transform: translateY(-50%);
          .decoration-line {
            position: absolute;
            width: 6px;
            height: 6px;
            background: #8FCDF3;
            top: 50%;
            transform: translateY(-50%);
          }
          &.left {
            left: -20px;
            .decoration-line {
              border-radius: 6px 0 0 6px;
              left: -4px;
            }
          }
          &.right {
            right: -20px;
            .decoration-line {
              border-radius: 0 6px 6px 0;
              right: -4px;
            }
          }
        }
      }
      .moreBox {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 16px;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        .lookMore {
          color: #666666;
        }
        /deep/ .el-icon-arrow-right {
          background: #C3C3C3;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          color: #FFFFFF;
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
    .listBox {
      width: 100%;
      display: flex;
      .listContainer{
        width: 100%;
        .goodList {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          gap: 21px;
          .goodItem {
            cursor: pointer;
            width: 284px;
            height: 380px;
            background: #FFFFFF;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            .img {
              width: 100%;
              height: 282px;
              background: #E4E4E4;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .soldOut1 {
                position: absolute;
                top: 0;
                left: 0;
                transform: scale(0.7);
              }
            }
            .info {
              flex: 1;
              padding: 10px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .storeCommodity {
                display: flex;
                align-items: center;
                gap: 6px;
                img {
                  height: 16px;
                }
                .commodityName {
                  font-size: 14px;
                  color: #333333;
                  flex: 1;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
              .commodityTag {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                gap: 6px;
                margin-top: 7px;
                .tag {
                  color: #ED732E;
                  font-size: 10px;
                  border: 1px solid #ED732E;
                  padding: 0 2px;
                }
              }
              .price {
                font-size: 14px;
                .retail {
                  color: #333333;
                  .symbol {
                    color: #333333;
                    font-size: 10px;
                  }
                }
                .original {
                  text-decoration: line-through;
                  color: #cccccc;
                  font-size: 10px;
                  .symbol {
                    color: #cccccc;
                    font-size: 10px;
                  }
                }
                .sold {
                  font-size: 12px;
                  color: #999999;
                  margin-left: 5px;
                }
              }
            }
          }
        }
        .noMore {
          color: #333333;
          font-size: 18px;
          font-weight: 500;
          height: 100px;
          line-height: 100px;
          text-align: center;
        }
        .load-data {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: #333333;
          font-size: 18px;
          font-weight: 500;
          align-items: center;
          height: 100px;
          .good-loading {
            display: flex;
            align-items: center;
            gap: 10px;
            /deep/.el-icon-loading {
              font-size: 25px;
            }
          }
          .good-last {

          }
        }
        /deep/ .el-pagination {
          .el-input {
            .el-input__inner {
              background: #ffffff;
            }
          }
        }
      }
    }
  }
</style>
